import script from "./ScrollableList.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollableList.vue?vue&type=script&setup=true&lang=js"

import "./ScrollableList.vue?vue&type=style&index=0&id=1a891eea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a891eea"]])

export default __exports__